import React, { Component } from 'react'
import './App.css'
import logo from './assets/scrunklogo.png'
import screeny1 from './assets/1.png'
import screeny2 from './assets/2.png'
import screeny3 from './assets/3.png'
import screeny4 from './assets/4.png'
import screeny5 from './assets/5.png'
// import screeny6 from './assets/6.png'
import twitter from './assets/twi.png'
import disc from './assets/disc.png'
import moon from './assets/moon.png'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      screeny: null,
      email: '',
      subscribed: false
    }
  }

  render() {
    return (
      <div>
        <div className="social">
          <a className="paddedImg" href="https://twitter.com/sleepystudios"><img src={twitter} alt="Icon" /></a>
          <a className="paddedImg" href="https://discord.gg/3R6u9QV"><img src={disc} alt="Icon" /></a>
          <a className="paddedImg" href="https://sleepystudios.net?utm_source=scrunk"><img src={moon} alt="Developed by Sleepy Studios" /></a>
        </div>

        <div className="logoWrapper">
          <img className="logo" src={logo} alt="Scrunk Logo" />          
        </div>

        <div className="desc">
          An online team-based building and raiding game<br/>Fight off mechs and infiltrate the enemy team's base while building up and defending your own
        </div>

        <div className="intro">
          {
            this.state.screeny ? 
            <span>
              <a href={this.state.screeny} target="_blank"><img className="trailer" src={this.state.screeny} alt="Screenshot" /></a>
              <span className="close" onClick={() => this.setState({screeny: null})}>X</span>              
            </span>
            :
            <iframe className="trailer" title="Scrunk Trailer" src="https://www.youtube-nocookie.com/embed/4e9IEsCpyek?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          }
          
          <div className="features">
            <span>
              <h3>Build your base</h3>
              <p>Fortify your team's base with traps, walls, barbed wire and turrets to ensure your core block is protected at all times from incoming raiders</p>
            </span>

            <span>
              <h3>Raid the enemy</h3>
              <p>Scavenge scrap from mechs and world events to craft explosives, bombs and guns to destroy the enemy's core block</p>             
            </span>

            <span>
              <h3>Fight for scrap</h3>
              <p>Dodge blast-zones or wait around to collect the scrap left behind. Fight off hordes of skitterers and shoot drones out of the sky to scavenge them for loot and scrap</p>             
            </span>
          </div>
        </div>

        <div className="gallery">
          <img className="thumb" onClick={() => this.setState({screeny: screeny1})} src={screeny1} alt="Screenshot 1" />
          <img className="thumb" onClick={() => this.setState({screeny: screeny2})} src={screeny2} alt="Screenshot 2" />
          <img className="thumb" onClick={() => this.setState({screeny: screeny3})} src={screeny3} alt="Screenshot 3" />
          <img className="thumb" onClick={() => this.setState({screeny: screeny4})} src={screeny4} alt="Screenshot 4" />       
          <img className="thumb" onClick={() => this.setState({screeny: screeny5})} src={screeny5} alt="Screenshot 5" />
          {/* <img className="thumb" onClick={() => this.setState({screeny: screeny6})} src={screeny6} alt="Screenshot 6" />               */}
        </div>

        <div className="steam">
          <iframe title="Buy Scrunk" src="https://store.steampowered.com/widget/818780/" frameborder="0" width="646" height="190"></iframe>
        </div>

        <p style={{color: 'white', textAlign: 'center'}}>
          A <a href="https://sleepystudios.net?utm_source=scrunk">Sleepy Studios</a> game. Available free on Steam for Windows, Mac and Linux.
          Want to get in touch? Email: <span style={{textDecoration: 'underline'}}>supportREMOVETHISBIT@sleepystudios.net</span>
        </p>
        
      </div>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js